import React, { useEffect, useRef } from 'react';
import { Container } from '@pixi/react';
import { slotSpineKey } from '../../../../../core/constants/symbolsNames';
import { Spine } from '../../../../../core/classes/spine';

function JackpotLogo() {
  const ref = useRef();

  useEffect(() => {
    if (ref.current) {
      const spine = new Spine({ key: slotSpineKey.jackpotBackGroundLogo });
      ref.current.addChild(spine);
    }
  }, []);

  return <Container ref={ref} name='JackpotBackGroundLogo' />;
}
export default JackpotLogo;
